export const setQueryConfig = (state, data) => {
  state.queryConfig = data;
  // console.warn("store queryConfig 成功", state);
}
export const setOrgId = (state, data) => {
  state.orgid = data;
}
export const setVoteInfo = (state, data) => {
  state.voteInfo = data;
}
export const setJwt = (state, data) => {
  state.jwt = data;
}
export const setVoteText = (state, data) => {
  state.voteText = data;
}
export const setActiveTab = (state, data) => {
  state.activeTab = data;
}
export const setTrackingOptions = (state, data) => {
  state.pageTrackingOptions = data;
}